import { GitError } from '../wasm-git-worker-errors.model';
import { GitErrorStatusCode } from './errors.enum';

export class NotAFileGitError extends GitError {
  constructor(path: string, append = true) {
    super(append ? `Element at "${path}" is not a file` : path);
  }

  readonly gitErrorCode = GitErrorStatusCode.NotAFile;
}
